/**
 * created by wang lei
 工具栏视频修改/新增 页面
 *
 */
import React, {Component} from 'react';
import {Input, InputNumber, Modal, Switch, Tooltip} from "antd";
import link from "./img/link.png";
import $Jq from 'jquery';
import {buildInsertVideoHtml} from "../../toolsSpace/tools/videoTool/videoTool";
import BaseComponent from "../../../../base/BaseComponent";
import videoNull from "./img/videoNull.png"
import linkBlue from "./img/linkBlue.png";
import leftSideIcon from "../image/leftside.png";
import leftCenterIcon from "../image/leftCenter.png";
import rightCenterIcon from "../image/rightCenter.png";
import centerIcon from "../image/center.png";
import $ from "jquery";
import {uuid} from "../../../../utils";

export default class VideoAmend extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            valueImg:'',
            value:'',
            sizeWidth:this.sysConfigGetValueByKey("editor.content.video.insert.width", "500"),
            sizeHeight:'',
            srcVideo:'',
            srcValue:'',
            picSrc:'',
            cssAutoPlay: eval(this.sysConfigGetValueByKey("editor.content.video.insert.autoplay", "false")),
            isDisplay:"none",
            isDisplayBlue:'block',
            float: null,
        }
    }

    open = (img) => {
        let {cssAutoPlay}=this.state;
        this.state.ratio =img.width/img.height
        if(this.props.title==="修改视频"){
            cssAutoPlay = (img.attributes && img.attributes.autoplay && img.attributes.autoplay.value && img.attributes.autoplay.value!="false") ? true : cssAutoPlay
        }
        let float = null;
        if(img.style.float){
            float = img.style.float;
        }else{
            let $imgParent = $(img).parent();
            if($imgParent.length > 0){
                if($imgParent.css("textAlign") === "center"){
                    float = "center";
                }
            }
        }
        this.setState({
            valueImg: img,
            sizeWidth: img.width,
            sizeHeight:img.height,
            srcVideo:$Jq(img).attr('video-src'),
            picSrc:img.src,
            visible:true,
            cssAutoPlay,
            float:float,
        })
    };

    onOk = () => {
        let {valueImg,sizeWidth,sizeHeight,srcVideo,picSrc,cssAutoPlay,float}= this.state;
        console.log(cssAutoPlay)
        if(this.props.title==="修改视频"){
            valueImg.style.width=sizeWidth+"px";
            valueImg.style.height=sizeHeight+"px";
            valueImg.width=sizeWidth;
            valueImg.height=sizeHeight;
            $Jq(valueImg).attr('autoplay',cssAutoPlay)
            $Jq(valueImg).attr('video-src',srcVideo);
            if(float == "center"){
                $Jq(valueImg).parent().css({"text-align":"center"})
                $Jq(valueImg).css("float", "");
            }else {
                $Jq(valueImg).parent().removeAttr("style")
                valueImg.style.float=float;
            }
            if(srcVideo && srcVideo.match(/(http|https):\/\/\S*/)){
                valueImg.src = videoNull
            }else if(srcVideo && srcVideo.match(/\/storage\/[A-Za-z0-9]{32,}\S*/)){
                this.request({
                    url: `/storage/getStorageFileByUrl?url=${srcVideo}`,
                    contentType: "json",
                    callBack: (data) => {
                        if(data){
                            valueImg.src = data.thumbnailsPlayPath
                        }
                    }
                });
            }else{
                valueImg.src = srcVideo
            }
        }else if(this.props.title==="插入视频"){
            this.getStorageFileByUrl()
        }
        this.onClose();
    };

    onClose = () => {
        if(typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall()
        }
        let video = document.getElementById(this.videoLabelId); // 获取视频元素
        video.pause(); // 暂停视频播放
        video.currentTime = 0; // 将视频时间设置为0
        this.setState({visible: false})
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    }

    videoLabelId = "a_"+uuid();
    render() {
        let baseStyle = {marginLeft:15,cursor:"pointer"};
        let defaultStyle = {...baseStyle,border:"1px solid #FFF"};
        let checkedStyle = {...baseStyle,borderTop:"solid 1px #000",borderLeft:"solid 1px #000",borderRight:"solid 1px #DCDCDC",borderBottom:"solid 1px #DCDCDC"};

        return (
            <div>
                <Modal
                    title={this.props.title}
                    visible={this.state.visible}
                    maskClosable={false}
                    width={1000}
                    onCancel={this.onClose}
                    onOk={this.onOk}
                >
                    <div style={{height:'380px',fontSize:"14px",color:"rgba(0, 0, 0, 0.65)"}}>
                        <div style={{marginBottom:'16px'}}>
                            <span>地址：</span>
                            <Input placeholder="" style={{width:'900px'}} value={this.state.srcVideo} onChange={e=>{
                                this.setState({srcVideo:e.target.value})
                            }}/>
                        </div>
                        <div style={{display: 'flex'}}>
                            <div style={{width:'592px',height:'333px'}}>
                                {this.state.srcVideo == "" || this.state.srcValue == null || this.state.srcValue == "undefined" ?
                                    <div style={{
                                        textAlign: "center",
                                        lineHeight: "333px",
                                        background: "rgb(242, 242, 242)",
                                        borderRadius: "5px"
                                    }}>请填写视频地址</div> : <video id={this.videoLabelId} controls src={this.state.srcVideo} style={{width:'100%',height:'100%',objectFit: 'contain'}}  controlsList={'nodownload'} ></video>}


                            </div>
                            <div style={{width: '40%', marginLeft: '32px'}}>
                                <div style={{margin: '16px 0', display: "flex",lineHeight: "32px"}}>
                                    宽度：  <InputNumber style={{width: 77}} min={0} value={this.state.sizeWidth}
                                                    onChange={value => {
                                                        if(!this.state.ratio){
                                                            let width = parseInt($(`#${this.videoLabelId}`).width());
                                                            let height = parseInt($(`#${this.videoLabelId}`).height());
                                                            this.state.ratio = width/height;
                                                        }
                                                        if (this.state.isDisplayBlue == "block") {
                                                            this.setState({
                                                                sizeWidth: value*1,
                                                                sizeHeight: (value / this.state.ratio).toFixed(0)*1
                                                            })
                                                        } else {
                                                            this.setState({sizeWidth: value*1})
                                                        }
                                                    }}/>
                                    <span style={{color: "rgba(0, 0, 0, 0.85)"}}>&nbsp;px&nbsp;</span>
                                    <img src={link} style={{margin: '5px 10px 0 10px',height:21,display: this.state.isDisplay,cursor:"pointer"}}
                                         onClick={() => {
                                             this.setState({isDisplayBlue:"block",isDisplay:"none"})
                                         }}
                                    />
                                    <img src={linkBlue} style={{
                                        margin: '5px 10px 0 10px',
                                        height: 21,
                                        display: this.state.isDisplayBlue,
                                        cursor: "pointer"
                                    }}
                                         onClick={() => {
                                             this.setState({isDisplayBlue: "none", isDisplay: "block"})
                                         }}/>
                                    高度：  <InputNumber min={0} style={{width: 77}} value={this.state.sizeHeight}
                                                    onChange={value => {
                                                        if (this.state.isDisplayBlue == "block") {
                                                            this.setState({
                                                                sizeHeight: value*1,
                                                                sizeWidth: (this.state.ratio * value).toFixed(0)*1
                                                            })
                                                        } else {
                                                            this.setState({sizeHeight: value*1})
                                                        }
                                                    }}/>
                                    <span style={{color: "rgba(0, 0, 0, 0.85)"}}>&nbsp;px</span>
                                </div>
                                <div style={{marginBottom:"16px"}}>
                                    浮动方式：
                                    <Tooltip title={"无浮动"} onClick={()=>{this.setState({float:null})}}><img style={this.state.float===null?checkedStyle:defaultStyle} src={leftSideIcon}/></Tooltip>
                                    <Tooltip title={"左浮动"} onClick={()=>{this.setState({float:"left"})}}><img style={this.state.float==="left"?checkedStyle:defaultStyle} src={leftCenterIcon}/></Tooltip>
                                    <Tooltip title={"右浮动"} onClick={()=>{this.setState({float:"right"})}}><img style={this.state.float==="right"?checkedStyle:defaultStyle} src={rightCenterIcon}/></Tooltip>
                                    <Tooltip title={"居中独占一行"} onClick={()=>{this.setState({float:"center"})}}><img style={this.state.float==="center"?checkedStyle:defaultStyle} src={centerIcon}/></Tooltip>
                                </div>
                                <div style={{display:"flex",justifyContent: "flex-end",marginRight: 10}}>
                                    <span>自动播放设置：</span>
                                    <Switch checkedChildren="开" unCheckedChildren="关" defaultChecked={this.state.cssAutoPlay}
                                            onChange={(value)=>{this.inputNumberOnChange(value, 'cssAutoPlay')}} />
                                </div>

                            </div>
                        </div>

                    </div>

                </Modal>
            </div>
        )
    }
    inputNumberOnChange (value, type='cssAutoPlay') {
        this.state[type] = value;
        this.setState({});
        console.log(this.state.autoplay)
    }
    //视频封面
    getStorageFileByUrl() {
        let {sizeWidth,sizeHeight,srcVideo,picSrc,cssAutoPlay,float}= this.state;
        if(srcVideo && srcVideo.match(/(http|https):\/\/\S*/)){
            let videoHTML = buildInsertVideoHtml({url:srcVideo,playUrl:videoNull,width:sizeWidth,newHeight:sizeHeight,autoplay:cssAutoPlay,name:"videoNull"})
            this.props.editor.rmtExecCommand("inserthtml", videoHTML);
        }else if(srcVideo && srcVideo.match(/\/storage\/[A-Za-z0-9]{32,}\S*/)){
            this.request({
                url: `/storage/getStorageFileByUrl?url=${srcVideo}`,
                contentType: "json",
                callBack: (data) => {
                    let picSrc = []
                    let videoPic = ''
                    let duration = ''
                    if(data){
                        picSrc = data.thumbnailsPlayPath
                        videoPic = data.thumbnailsPath
                        duration = data.duration
                    }
                    this.setState({picSrc,videoPic,duration})
                    let videoHTML = buildInsertVideoHtml({url:srcVideo,playUrl:picSrc,videoPic:videoPic,duration:duration,width:sizeWidth,newHeight:sizeHeight,autoplay:cssAutoPlay,float:float})
                    this.props.editor.rmtExecCommand("inserthtml", videoHTML);
                }
            });
        }else{
            let videoHTML = buildInsertVideoHtml({url:srcVideo,playUrl:picSrc,width:sizeWidth,newHeight:sizeHeight,autoplay:cssAutoPlay,float:float})
            this.props.editor.rmtExecCommand("inserthtml", videoHTML);
        }

    }
}